import { createInertiaApp } from '@inertiajs/react'
import { createElement, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import RootErrorBoundary from '@/components/RootErrorBoundary'
import { installStandaloneRecovery } from '@/lib/standalone-recovery'

type ResolvedComponent = {
  default: ReactNode
  layout?: (page: ReactNode) => ReactNode
}

// Browser-only: reload a frozen iOS Home Screen (standalone) app on resume.
// Not mirrored in ssr.tsx — it touches window/document and must not run in Node.
installStandaloneRecovery()

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>('../pages/**/*.tsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
    }
    return page
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(
        createElement(RootErrorBoundary, null, createElement(App, props)),
      )
    } else {
      console.error(
        'Missing root element. Move `vite_typescript_tag "inertia"` into an Inertia-specific layout.',
      )
    }
  },
})
